import styled from '@emotion/styled'
import clickArrow from '../assets/05_button/回到頂部(點擊).png'

export default function ReturnTop() {
  const Container = styled.div`
        width: 60px;
        height: 60px;
        border-radius: 30px;
        position: fixed;
        right: 50px;
        bottom: 50px;
        opacity: 0.6;

        &:hover {
          opacity: 1;
        }
    `
  return (
      <Container>
        <a href='#top'>
          <img src={clickArrow} alt="回到頂部" style={{width: '100%'}} />
        </a>
      </Container>
  )
}
